import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { sheetImportErrorsAtom } from './atoms'

export function ImportErrorDisplay() {
  const errors = useAtomValue(sheetImportErrorsAtom)

  if (errors.length === 0) {
    return null
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom color="error">
        Import Errors ({errors.length})
      </Typography>
      <Box
        sx={{
          backgroundColor: 'error.light',
          p: 2,
          borderRadius: 1,
          maxHeight: '400px',
          overflow: 'auto',
        }}
      >
        {errors.map((error, index) => (
          <Box key={index} sx={{ mb: 1 }}>
            <Typography variant="body2" component="div">
              <strong>Row {error.row}:</strong> {error.message}
              {error.data && (
                <Typography
                  variant="caption"
                  component="div"
                  sx={{ ml: 2, color: 'text.secondary' }}
                >
                  {error.data}
                </Typography>
              )}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
